import useInstallPrompt from "../hooks/useInstallPrompt";
import BottomSheet from "./BottomSheet";
import Button from "./Button";
import styles from "./InstallPrompt.module.css";

const InstallPrompt = () => {
  const { variant, install, dismiss } = useInstallPrompt();

  return (
    <BottomSheet isOpen={variant !== null} onClose={dismiss}>
      <div className={styles.content}>
        <img src="/icon-192.png" alt="" className={styles.icon} />
        <h3>Install OnlyClicks</h3>
        <p className={styles.body}>
          Add it to your home screen to reach your setups in one tap, even at
          the trailhead.
        </p>
        {variant === "instructions" ? (
          <ol className={styles.steps}>
            <li>Tap the Share button in Safari</li>
            <li>Choose &ldquo;Add to Home Screen&rdquo;</li>
          </ol>
        ) : (
          <Button
            fullWidth
            buttonProps={{ className: styles.install, onClick: install }}
          >
            Install
          </Button>
        )}
        <Button
          type="secondary"
          fullWidth
          buttonProps={{ className: styles.dismiss, onClick: dismiss }}
        >
          Not now
        </Button>
      </div>
    </BottomSheet>
  );
};

export default InstallPrompt;
